var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Value } from '@sinclair/typebox/value';
import { cartCustomerSchema } from "./cart/customer.mjs";
import { objectIsEmpty } from "./utils.mjs";
const localStorageKey = 'stickerapp.checkout.customer';
export const setCustomerDataFromLocalStorageIfNeeded = (state, actions) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    // We don't want to apply anything from local storage if we already have
    // customer data in the state. And we don't want to apply just the properties
    // that are empty because then we might mix and match data from different
    // people.
    if (!objectIsEmpty(state.customer)) {
        return;
    }
    const savedCustomerData = loadCustomerData();
    if (savedCustomerData) {
        const customer = Value.Cast(cartCustomerSchema, savedCustomerData);
        const company = customer.company || {};
        const actionsToCall = [
            { value: customer.email, action: actions.setEmail },
            { value: customer.phoneNumber, action: actions.setPhoneNumber },
            { value: company.isCompany, action: actions.setIsCompany },
            { value: company.name, action: actions.setCompanyName },
            { value: (_a = company.vatNumber) === null || _a === void 0 ? void 0 : _a.value, action: actions.setVatNumber },
            { value: customer.useBillingAddress, action: actions.setUseBillingAddress },
            { value: customer.address, action: actions.setAddress },
            { value: customer.billingAddress, action: actions.setBillingAddress },
        ];
        const promises = [];
        for (const { value, action } of actionsToCall) {
            if (value !== undefined) {
                // Note that we don't await the action here because we
                // want to batch them all into a single request
                promises.push(action(value));
            }
        }
        yield Promise.all(promises);
    }
});
const loadCustomerData = () => {
    try {
        const value = localStorage.getItem(localStorageKey);
        if (!value) {
            return undefined;
        }
        return JSON.parse(value !== null && value !== void 0 ? value : '');
    }
    catch (_a) {
        return undefined;
    }
};
export const saveCustomerDataToLocalStorage = (state) => {
    // Otherwise we might clear the customer data from local storage
    // when a new cart is created
    if (objectIsEmpty(state.customer)) {
        return;
    }
    try {
        localStorage.setItem(localStorageKey, JSON.stringify(state.customer));
    }
    catch (_a) {
        // We don't want to crash the app if we can't save to local storage
        // which can happen in private browsing mode
    }
};
//# sourceMappingURL=customer.js.map